import { useCallback } from 'react';
import _isEmpty from 'lodash/isEmpty';
function useQueryParams(query) {
  if (typeof window === 'undefined') {
    return {
      get: function get() {
        return null;
      },
      set: function set() {}
    };
  }
  var get = function get() {
    if (_isEmpty(query)) {
      return null;
    }
    var search = window.location.search;
    var params = new URLSearchParams(search);
    return params.get(query);
  };
  var set = useCallback(function (value) {
    if (_isEmpty(query)) {
      return;
    }
    var url = new URL(window.location);
    var params = new URLSearchParams(url.search);
    params.set(query, value);
    url.search = params.toString();
    window.history.replaceState({}, '', url);
  }, [query]);
  return {
    get: get,
    set: set
  };
}
export default useQueryParams;